import { render, staticRenderFns } from "./KoutsuhiInputPage.vue?vue&type=template&id=4762cef6&scoped=true&"
import script from "./KoutsuhiInputPage.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiInputPage.vue?vue&type=script&lang=ts&"
import style0 from "./KoutsuhiInputPage.vue?vue&type=style&index=0&id=4762cef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4762cef6",
  null
  
)

export default component.exports